import { Box, CircularProgress, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiError } from '../../ApiLoadingGuard/ApiLoadingGuard';
import { HeapImageWithBoxes } from '../../Heap/HeapImageWithBoxes';
import { HeapDetection } from '../../Heap/types';
import { HeapMaskOverlay } from '../../Heap/heapMasks';

interface HeapDetailsImageCardProps {
  isLoading: boolean;
  error: ApiError | null;
  heapImage: string | undefined;
  detections: HeapDetection[];
  segmentationOverlays?: readonly HeapMaskOverlay[];
}

export function HeapDetailsImageCard({
  isLoading,
  error,
  heapImage,
  detections,
  segmentationOverlays,
}: HeapDetailsImageCardProps): ReactElement {
  const { t } = useTranslation();
  return (
    <Box display='flex' justifyContent='center' alignItems='center' flex={1} minHeight='520px'>
      {isLoading ? (
        <CircularProgress />
      ) : error ? (
        <Typography>{t('error.imageDisplay')}</Typography>
      ) : heapImage ? (
        <HeapImageWithBoxes imageSrc={heapImage} detections={detections} segmentationOverlays={segmentationOverlays} />
      ) : (
        <Typography color='text.secondary' variant='body2'>
          {t('error.imageNotAvailable')}
        </Typography>
      )}
    </Box>
  );
}
